/*! Bootstrap 5 Carousel Swipe jQuery plugin */
import $ from 'jquery';

(($) => {
  $.fn.bs5CarouselSwipe = function(options = {}) {
    const defaults = {
      threshold: 50,
      preventDefaultTouchmoveEvent: false
    };

    const settings = { ...defaults, ...options };

    return this.each(function() {
      const element = this;
      const carousel = element._bootstrap5Carousel;

      if (!carousel) {
        console.warn('Bootstrap 5 carousel instance not found on element');
        return;
      }

      // Create a swipe handler class for better organization
      class SwipeHandler {
        constructor(element, carousel, settings) {
          this.element = element;
          this.carousel = carousel;
          this.settings = settings;
          this.startX = null;
          this.startY = null;
          this.isSwiping = false;

          this.init();
        }

        init() {
          if (!('ontouchstart' in document.documentElement)) {
            return;
          }

          this.element.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
          this.element.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true });
        }

        handleTouchStart(e) {
          if (e.touches.length !== 1) return;

          const { pageX, pageY } = e.touches[0];
          this.startX = pageX;
          this.startY = pageY;
          this.isSwiping = true;

          this.element.addEventListener('touchmove', this.handleTouchMove.bind(this), {
            passive: !this.settings.preventDefaultTouchmoveEvent
          });
        }

        handleTouchMove(e) {
          if (!this.isSwiping) return;

          const { pageX: currentX, pageY: currentY } = e.touches[0];
          const deltaX = this.startX - currentX;
          const deltaY = this.startY - currentY;

          // Check if horizontal swipe (not vertical scroll)
          if (Math.abs(deltaX) > Math.abs(deltaY)) {
            if (this.settings.preventDefaultTouchmoveEvent) {
              e.preventDefault();
            }

            if (Math.abs(deltaX) >= this.settings.threshold) {
              this.cleanup();

              // Use ternary operator for cleaner code
              deltaX > 0 ? this.carousel.next() : this.carousel.prev();
            }
          }
        }

        handleTouchEnd() {
          this.cleanup();
        }

        cleanup() {
          this.element.removeEventListener('touchmove', this.handleTouchMove.bind(this));
          this.startX = null;
          this.startY = null;
          this.isSwiping = false;
        }
      }

      // Initialize the swipe handler
      new SwipeHandler(element, carousel, settings);
    });
  };
})($);
